import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaBullhorn, FaBell, FaBuilding } from "react-icons/fa";
import "./Header.css";
import mainlogo from "../../src/main/dashboard/assets/mainlogo5.png";
import GetLeadsModal from "../main/dashboard/GetLeadsModal";
import { getLoggedCompany  } from "../utils/auth.js";
/* MOBILE ICONS */
import profileIcon from "../../src/main/dashboard/assets/profile.png";
import homeIcon from "../../src/main/dashboard/assets/home.png";
import getLeadsIcon from "../../src/main/dashboard/assets/get-leads.png";  
import servicesIcon from "../../src/main/dashboard/assets/categories.png";
import newsIcon from "../../src/main/dashboard/assets/news.png";
import helpIcon from "../../src/main/dashboard/assets/help.png";
/* ✅ HELP MODAL */
import Helpmodel from "../main/dashboard/HelpModal";
import ProfileSidebar from "./ProfileSidebar";


const Header = () => {
  const [openLeads, setOpenLeads] = useState(false);
  const [showLeads, setShowLeads] = useState(false);
  const [showAdvertiseComingSoon, setShowAdvertiseComingSoon] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [company, setCompany] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);

  // close dropdown on outside click
useEffect(() => {
  const close = (e) => {
    if (!e.target.closest(".jd-profile-wrap")) {
      setShowProfileMenu(false);
    }
  };
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);

  // ✅ Load logged-in company
  useEffect(() => {
    const data = getLoggedCompany();
    setCompany(data);
  }, []);
  const profileImage = company?.photo_url
    ? `${process.env.REACT_APP_API_URL}${company.photo_url}`
    : profileIcon; // add default image in public/

    
useEffect(() => {
  const loadCompany = () => {
    setCompany(getLoggedCompany());
  };

  loadCompany();

  // 🔁 Listen to login/logout changes
  window.addEventListener("storage", loadCompany);
  return () => window.removeEventListener("storage", loadCompany);
}, []);




  /* ✅ HELP MODAL STATE */
  const [openHelp, setOpenHelp] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setShowAdvertiseComingSoon(false);
        setShowNotifications(false);
        setOpenHelp(false);
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <>
      {/* ================= DESKTOP HEADER ================= */}
      <header className="jd-header desktop-header">
        <div className="jd-container">
          <div className="jd-logo-zone">
            <Link to="/" className="jd-logo">
              <img src={mainlogo} alt="BizMark Logo" />
            </Link>
          </div>


          <nav className="jd-nav">

            <Link to="/agency" className="jd-link agency-highlight">
  <FaBuilding />
  <span>Agency</span>
</Link>

            <button className="jd-link" onClick={() => setOpenLeads(true)}>
              <FaEnvelope />
              <span>Get Leads</span>
            </button>

            <GetLeadsModal open={openLeads} onClose={() => setOpenLeads(false)} />

            <button
              className="jd-link"
              onClick={() => setShowAdvertiseComingSoon(true)}
            >
              <FaBullhorn />
              <span>Advertise</span>
            </button>

            <Link to="/business-listing" className="jd-link">
              <span className="jd-badge">BUSINESS</span>
              <span>Free Listing</span>
            </Link>

            <button
              className="jd-bell"
              onClick={() => setShowNotifications(true)}
              aria-label="Open notifications"
            >
              <FaBell />
            </button>

            {/* ================= AUTH SECTION (DESKTOP) ================= */}
{company ? (
  <>
    <div
      className="jd-profile-wrap"
      onClick={() => setOpenProfile(true)}
      style={{ cursor: "pointer" }}
    >
      <img
        src={profileImage}
        alt="Profile"
        className="jd-profile-img"
      />
      {showProfileMenu && (
  <div className="profile-sidebar-overlay" onClick={() => setShowProfileMenu(false)}>
    <aside
      className="profile-sidebar"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="sidebar-close"
        onClick={() => setShowProfileMenu(false)}
      >
        ✕
      </button>

      <div className="sidebar-profile">
        <img src={profileImage} alt="Profile" />
        <h4>{company?.company_name}</h4>
      </div>

      <Link to="/profilepage">My Profile</Link>
      <Link to="/business-listing">My Business</Link>

      <button
        className="logout-btn"
        onClick={() => {
          localStorage.removeItem("company");
          window.location.replace("/login");
        }}
      >
        Logout
      </button>
    </aside>
  </div>
)}

      <span className="jd-profile-name">
        {company.company_name}
      </span>
    </div>

    <ProfileSidebar
      open={openProfile}
      onClose={() => setOpenProfile(false)}
      company={company}
      profileImage={profileImage}
    />
  </>
) : (
  <Link to="/login" className="jd-login-btn">
    Login / Sign Up
  </Link>
)}




          </nav>
        </div>
      </header>

      {/* ================= MOBILE TOP HEADER ================= */}
      <header className="mobile-app-header">
        <div className="mobile-top-bar">
          <Link to="/">
            <img src={mainlogo} alt="BizMark" className="mobile-logo" />
          </Link>

          <Link to="/business-listing" className="mobile-business-btn">
            <span className="mobile-business-badge">BUSINESS</span>
            <span className="mobile-business-text">Free Listing</span>
          </Link>

          <Link to="/profilepage">
            <img
              src={profileImage}
              alt="Profile"
              className="mobile-profile-icon"
            />
          </Link>
        </div>
      </header>

      {/* ================= MOBILE BOTTOM NAV ================= */}
      <nav className="mobile-bottom-nav">
        <Link to="/" className="mobile-menu-item">
          <img src={homeIcon} alt="Home" />
          <span>Home</span>
        </Link>

        <Link
          to="#"
          className="mobile-menu-item"
          onClick={(e) => {
            e.preventDefault();
            setShowLeads(true);
          }}
        >
          <img src={getLeadsIcon} alt="Get Leads" />
          <span>Get Leads</span>
        </Link>

        <GetLeadsModal open={showLeads} onClose={() => setShowLeads(false)} />

        <Link to="/all-categories" className="mobile-menu-item">
          <img src={servicesIcon} alt="Services" />
          <span>Services</span>
        </Link>

        <Link to="/article1" className="mobile-menu-item">
          <img src={newsIcon} alt="News" />
          <span>News</span>
        </Link>

        {/* ✅ HELP OPENS MODAL (COPIED FROM HEADER1) */}
        <div
          className="mobile-menu-item"
          onClick={() => setOpenHelp(true)}
          style={{ cursor: "pointer" }}
        >
          <img src={helpIcon} alt="Help" />
          <span>Help</span>
        </div>
      </nav>

      {/* ================= HELP MODAL ================= */}
      <Helpmodel isOpen={openHelp} onClose={() => setOpenHelp(false)} />

      {/* ================= ADVERTISE COMING SOON ================= */}
      {showAdvertiseComingSoon && (
        <div
          className="coming-soon-overlay"
          onClick={() => setShowAdvertiseComingSoon(false)}
        >
          <div
            className="coming-soon-modal"
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="coming-soon-close"
              onClick={() => setShowAdvertiseComingSoon(false)}
            >
              ✕
            </button>
            <h3>Coming Soon</h3>
            <p>
              Advertising features are currently under development.
              We’ll be launching this soon.
            </p>
            <button
              className="coming-soon-action"
              onClick={() => setShowAdvertiseComingSoon(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      {/* ================= NOTIFICATION DRAWER ================= */}
      {showNotifications && (
        <div
          className="notification-overlay"
          onClick={() => setShowNotifications(false)}
        >
          <aside
            className="notification-drawer"
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="notification-header">
              <h3>Notifications</h3>
              <button
                className="notification-close"
                onClick={() => setShowNotifications(false)}
              >
                ✕
              </button>
            </div>
            

                   <div className="notification-list">
              <div className="notification-item">
                <div className="notification-icon">🔔</div>
                <div className="notification-content">
                  <strong>New businesses added near you</strong>
                  <p>Explore newly listed services in your area.</p>
                  <span className="notification-time">2h ago</span>
                </div>
              </div>

              <div className="notification-item">
                <div className="notification-icon">📈</div>
                <div className="notification-content">
                  <strong>Your listing received new views</strong>
                  <p>More customers are discovering your business.</p>
                  <span className="notification-time">Yesterday</span>
                </div>
              </div>

              <div className="notification-item">
                <div className="notification-icon">✨</div>
                <div className="notification-content">
                  <strong>New feature launching soon</strong>
                  <p>We’re rolling out exciting upgrades.</p>
                  <span className="notification-time">3 days ago</span>
                </div>
              </div>

              {/* Optional empty state */}

              
              {/* <div className="notification-empty">You’re all caught up 🎉</div> */}
            </div>



          </aside>
        </div>
      )}
    </>
  );
};

export default Header;